import React from 'react';
import styled from 'styled-components';
import { getImage } from 'gatsby-plugin-image';
import Image from 'gatsby-theme-core/src/components/image';
import Content from 'gatsby-theme-core/src/components/content';

const SponsorsCategory = ({ title, color, items }) => items?.length > 0 && (
  <Wrapper>
    <TitleWrapper>
      <Squares color={color}>
        <Square />
        <Square />
        <Square />
      </Squares>
      <Title color={color}>{title}</Title>
    </TitleWrapper>
    {items.map(({
      id,
      title: itemTitle,
      url,
      logo,
      text,
    }) => (
      <Item key={id}>
        {getImage(logo?.localFile) && (
          <StyledOutboundLink href={url}>
            <Image
              image={logo}
              alt={itemTitle}
            />
          </StyledOutboundLink>
        )}
        <ContentWrapper>
          <Label color={color}>
            <span>{title.charAt(0)}</span>
            <span>{title}</span>
          </Label>
          {text && (
            <StyledContent
              $content={text}
            />
          )}
        </ContentWrapper>
      </Item>
    ))}
  </Wrapper>
);

const Label = styled.span`
  display: inline-flex;
  border: 1px solid ${({ color }) => color};
  font-size: .75rem;
  margin-bottom: 1rem;
  margin-top: 1rem;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    margin-top: 0;
  }

  span {
    display: flex;
    font-weight: 700;

    &:first-child {
      padding: .35rem .5rem;
      color: ${({ color }) => color};
    }

    &:last-child {
      padding: .35rem;
      background-color: ${({ color }) => color};
      color: white;
      height: 100%;
    }
  }
`;

const Square = styled.span`
  display: inline-block;
  height: 1.5rem;
  width: 3rem;
  clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);
`;

const Squares = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-end;
  width: 90%;
  margin-bottom: -1px;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    display: inline-flex;
    margin-bottom: 0;
  }

  &:after {
    display: block;
    position: absolute;
    left: 0;
    top: 1.5rem;
    right: .75rem;

    content: "";
    height: 2px;
    background-color: ${({ color }) => color};
  }

  ${Square} {
    background-color: ${({ color }) => color};
  }
`;

const Title = styled.h2`
  margin: 0;
  padding: .75rem 1rem;
  font-size: 1.25rem;
  text-transform: uppercase;
  color: white;
  background-color: ${({ color }) => color};
`;

const TitleWrapper = styled.div`

  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    display: grid;
    grid-gap: ${({ theme }) => theme.grid.columnGap};
    grid-template-columns: 1fr auto;
    margin-bottom: 1rem;
  }
`;

const Wrapper = styled.article`
  padding: 40px 0;
`;

const Item = styled.div`
  padding: 15px 0;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    display: flex;
    align-items: center;
  }
`;

const StyledOutboundLink = styled.a`
  display: block;
  text-align: center;
`;

const ContentWrapper = styled.div`
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    padding-left: 40px;
  }
`;
const StyledContent = styled(Content)`
  p {
    margin: 0;
    line-height: 160%;
  }
`;

export default SponsorsCategory;
